module.exports = __webpack_public_path__ + "BF.png?3a608a42b940d9c6459a78103b8dc752";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/BF.png
// module id = 332
// module chunks = 0